
import { Component, Prop, VModel, Vue } from "vue-property-decorator";

@Component
export default class TotalInteractionsChartInfoCard extends Vue {

  @VModel({ required: true }) show!: boolean;
}

